import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  PESQUISA_EMPRESAS,
  PESQUISA_SISTEMAS_POR_EMPRESA,
} from '../../../../services/permissoesRecebidas.js';
import useFetch from '../../../../components/hooks/useFetch.js';
import { useLocation, useNavigate } from 'react-router-dom';
import './TelaPermissoesRecebidas.scss';
import iconePermissoes from '../../../../assets/img/icones/personalizados/permissoes-cor.svg';
import Select from '../../../../components/form/Select.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import FormExcluirSistema from './FormExcluirSistema.js';
import FormExcluirGrupo from './FormExcluirGrupo.js';

const TelaPermissoesRecebidasSistemas = () => {
  const { t } = useTranslation();
  const { register, handleSubmit, errors, control } = useForm();
  const {
    request: requestPermissoesRecebidas,
    data: dadosPermissoesRecebidas,
  } = useFetch();
  const { request: requestEmpresas, data: dadosEmpresas } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  const [modalAbertoExcluirSistema, setModalAbertoExcluirSistema] = useState(false);
  const [modalAbertoExcluirGrupo, setModalAbertoExcluirGrupo] = useState(false);
  const [permissaoRecebidaSelecionada, setPermissaoRcebidaSelecionada] = useState();
  const [grupoSelecionado, setGrupoSelecionado] = useState();
  const [idCorreiosPJSelecionado, setIdCorreiosPJSelecionado] = useState();
  const [alterei, setAlterei] = useState(false);

  useEffect(() => {
    if (dados.idCorreios && dados.idCorreios != '') {
      requestEmpresas(PESQUISA_EMPRESAS(dados.idCorreios));
    } else navigate('/login');
  }, [dados]);

  const handleEscolherEmpresa = (event) => {
    let idCorreiosPJ = event.target.value;
    if (idCorreiosPJ)
      setIdCorreiosPJSelecionado(idCorreiosPJ);
      requestPermissoesRecebidas(
        PESQUISA_SISTEMAS_POR_EMPRESA(dados.idCorreios, idCorreiosPJ),
      );
  };

  const abreModalExcluirGrupo = (permissaoRecebida, grupo) => {
    setPermissaoRcebidaSelecionada(permissaoRecebida);
    setGrupoSelecionado(grupo);
    setModalAbertoExcluirGrupo(true);
  };

  const abreModalExcluirSistema = (permissaoRecebida) => {
    setPermissaoRcebidaSelecionada(permissaoRecebida);
    setModalAbertoExcluirSistema(true);
  };

  const fechar = () => {
    setAlterei(true);
    setModalAbertoExcluirGrupo(false);
    setModalAbertoExcluirSistema(false);
  };
  
  useEffect(() => {
    if (dados.idCorreios && dados.idCorreios != '' && idCorreiosPJSelecionado && idCorreiosPJSelecionado != ''){
      requestPermissoesRecebidas(
        PESQUISA_SISTEMAS_POR_EMPRESA(dados.idCorreios, idCorreiosPJSelecionado),
      );
    }
      setAlterei(false);
  }, [alterei]);

  return (
    <>
      <div className="conteudo permissoes-recebidas">
        <h1>{t('principal.received_permissions.systems_title')}</h1>

        <Select
          options={
            dadosEmpresas
              ? [
                  { label: t('principal.received_permissions.select_company'), value: '' },
                  ...dadosEmpresas.map((item) => ({
                    value: item.idCorreios,
                    label: item.nome,
                  })),
                ]
              : [{ label: t('principal.received_permissions.select_company'), value: '' }]
          }
          name="empresa"
          inputref={register}
          errors={errors}
          //label="Empresas"
          id="idCorreiosPJ"
          onChange={handleEscolherEmpresa}
        />

        <div className="cards-container">
          {dadosPermissoesRecebidas?.length === 0 && (
            <h6>{t('principal.received_permissions.no_systems_found')}</h6>
          )}

          {dadosPermissoesRecebidas?.map((item, index) => (
            <div className="card card-permissao bg-superficie">
              <div className="card-header">
                <div className="card-header-img">
                  <img alt="ícones de chavers" src={iconePermissoes} />
                </div>
                <h6>{item.iprojTi.nome}</h6>
                <button 
                  className='btn-txt so-icone' 
                  title='Excluir Sistema'
                  onClick={() => abreModalExcluirSistema(item)}>
                    <i className='ic-lixo'></i>
                </button>
              </div>

              <div className="card-body">
                <p className="mini">Descrição do Sistema</p>
                <p className="small">{item.iprojTi.descricao}</p>
                <br />
                <p className="mini">Links</p>
                <a className="small" href={item.iprojTi.urlHomologacao}>
                  Link de homologação
                </a>{' '}
                <br />
                <a className="small" href={item.iprojTi.urlProducao}>
                  Link de produção
                </a>
                <br />
                <br />
                <p className="mini">Grupo concedido</p>
                {item.grupos?.map((grupo, index) => (
                  <div className='grupo'>
                    <div>
                      <h6>{grupo.nome}</h6>
                      <p className="small">{grupo.descricao}</p>
                    </div>
                    <button 
                      className='btn-txt so-icone' 
                      title='Excluir grupo'
                      onClick={() => abreModalExcluirGrupo(item, grupo)}>

                        <i className='ic-lixo'></i>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button className="btn-pre" onClick={() => navigate('/principal')}>
          {t('principal.forms.buttons.back')}
        </button>
      </div>

      <ModalDialog
        id="modal-excluir-sistema"
        aberto={modalAbertoExcluirSistema}
        setAberto={setModalAbertoExcluirSistema}
        opcaoFechar={true}
      >
        <FormExcluirSistema
          acaoCancelar={() => setModalAbertoExcluirSistema(false)}
          acaoFechar={fechar}
          idCorreios={dados.idCorreios}
          idCorreiosPJ={idCorreiosPJSelecionado}
          permissaoRecebidaSelecionada={permissaoRecebidaSelecionada}
        />
      </ModalDialog>

      <ModalDialog
        id="modal-excluir-grupo"
        aberto={modalAbertoExcluirGrupo}
        setAberto={setModalAbertoExcluirGrupo}
        opcaoFechar={true}
      >
        <FormExcluirGrupo
          acaoCancelar={() => setModalAbertoExcluirGrupo(false)}
          acaoFechar={fechar}
          idCorreios={dados.idCorreios}
          idCorreiosPJ={idCorreiosPJSelecionado}
          grupoSelecionado={grupoSelecionado}
          permissaoRecebidaSelecionada={permissaoRecebidaSelecionada}
        />
      </ModalDialog>
    </>
  );
};

export default TelaPermissoesRecebidasSistemas;
